import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="container-footer">
      <p>
        Meet me in <a className="white-text" href="https://www.linkedin.com/in/adila-zahra-faradisa-b3a840203/">Linkedin</a>
        {/* <a className="white-text" href="https://www.linkedin.com/in/adila-zahra-faradisa-b3a840203/">Linkedin</a> */}
      </p>
    </footer>
  );
};
